interface PlatformEnrollableOrganization {
    platformEnabledAt: Date | null;
}

export const isPlatformEnabled = (
    organization: PlatformEnrollableOrganization,
): boolean => organization.platformEnabledAt !== null;
